import logo from "./logo.png";
import userheaderimg from "./header-user-profile.png";
import user from "./user.png";
import admin from "./admin.png";
import notification from "./notification.png";
import avatar from "./avatar.png";
import Upload from "./Upload.png";
import Background from "./background.png";

const IMAGES = {
  LOGO: logo,
  ADMIN: admin,
  USER_HEADER_IMG: userheaderimg,
  BELL_ICON: notification,
  USER: user,
  AVATAR: avatar,
  UPLOAD_FILE: Upload,
  BACKGROUND: Background,
};
export default IMAGES;
